module.exports = __webpack_public_path__ + "static/media/uac.79201859.png";